"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = "wordlists/5.0.2";
//# sourceMappingURL=_version.js.map